import { cva } from "class-variance-authority";

export { default as Icon } from "./Icon.vue";

export const sizes = [
    "2xs",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl",
    "3xl",
    "full",
];

export const variants = cva(["shrink-0", "block"], {
    variants: {
        size: {
            "2xs": ["w-2.5", "h-2.5"],
            xs: ["w-3", "h-3"],
            sm: ["w-3.5", "h-3.5"],
            md: ["w-4", "h-4"],
            lg: ["w-4.5", "h-4.5"],
            xl: ["w-5", "h-5"],
            "2xl": ["w-6", "h-6"],
            "3xl": ["w-8", "h-8"],
            "4xl": ["w-10", "h-10"],
            full: ["w-full", "h-full"],
        },
    },
});
